import { type ReactNode, useState } from "react";
import { ChevronDown, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { SectionTransition } from "@/components/motion/SectionTransition";

interface SectionGroupProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  className?: string;
}

export function SectionGroup({
  title,
  children,
  defaultOpen = true,
  className,
}: SectionGroupProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={cn("glass rounded-md border border-border/40 overflow-hidden", className)}>
      <Button
        variant="ghost"
        onClick={() => setIsOpen(!isOpen)}
        className="w-full justify-between p-4 rounded-none hover:bg-accent/50"
      >
        <span className="font-semibold text-left">{title}</span>
        <motion.div
          animate={{ rotate: isOpen ? 90 : 0 }}
          transition={{ duration: 0.2 }}
        >
          {isOpen ? (
            <ChevronDown className="w-4 h-4" />
          ) : (
            <ChevronRight className="w-4 h-4" />
          )}
        </motion.div>
      </Button>
      <SectionTransition isOpen={isOpen}>
        <div className="p-4 pt-0 space-y-4">{children}</div>
      </SectionTransition>
    </div>
  );
}

